import React from 'react';
import './SetupEmail.css'

function SetupEmail () {
    
        return (
            <div>
 <div className="pageHeader">

      <div className="pageHeaderLeft">

        <div className="pageTitle">
          Cấu hình email/SMS
        </div>

        <div className="breadcrumb">

          <span className="breadcrumbText">
            Trang chủ
          </span>

          <span>/</span>

          <span className="breadcrumbText">
            Cấu hình hệ thống
          </span>

          <span>/</span>

          <span className="breadcrumbActive">
            Cấu hình email/SMS
          </span>

        </div>

      </div>

      <button className="saveConfigButton">

        <i className="fa-solid fa-floppy-disk"></i>

        Lưu cấu hình

      </button>

    </div>

    {/* <!-- TAB --> */}
    <div className="tabWrapper">

      <div className="tabItem tabItemActive">
        Email
      </div>

      <div className="tabItem">
        SMS
      </div>

    </div>

    {/* <!-- EMAIL --> */}
    <div className="sectionWrapper">

      <div className="sectionTitle">
        Cấu hình email
      </div>

      <div className="switchRow">

        <div className="switchLabel">
          Bật chức năng gửi email
        </div>

        <label className="switch">

          <input type="checkbox" checked />

          <span className="slider"></span>

        </label>

      </div>

      <div className="formGrid">
          {/* dòng 1 */}
        {/* <!--  Máy chủ SMTP --> */}
        <div className="formGroup">

          <label className="formLabel">
            Máy chủ SMTP <span className="required">*</span>
          </label>

          <input
            type="text"
            className="formInputServer"
            value="smtp.angiang.gov.vn"
          />

        </div>

        {/* <!-- Giao thức bảo mật -> */}
        <div className="formGroupKey">

          <label className="formLabel">
            Giao thức bảo mật <span className="required">*</span>
          </label>

          <select className="formSelectKey">

            <option>
              TLS
            </option>

          </select>

        </div>

        {/* <!-- AUTH --> */}
        <div className="formGroupVerify">

          <label className="formLabel">
            Xác thực
          </label>

          <select className="formSelectVerify">

            <option>
              Đăng nhập
            </option>

          </select>

        </div>

        {/* <!--  Cổng (Port) --> */}
        <div className="formGroupPort">

          <label className="formLabel">
            Cổng (Port) <span className="required">*</span>
          </label>

          <input
            type="number"
            className="formInputPort"
            value="587"
          />

        </div>

        {/* <!-- USERNAME --> */}
        <div className="formGroupUser">

          <label className="formLabel">
            Tên đăng nhập (Username) <span className="required">*</span>
          </label>

          <input
            type="text"
            className="formInputUser"
            value="noreply@angiang.gov.vn"
          />

        </div>

        {/* <!-- TIMEOUT --> */}
        <div className="formGroupWait">

          <label className="formLabel">
            Thời gian chờ (giây)
          </label>

          <input
            type="number"
            className="formInputWait"
            value="30"
          />

        </div>

        {/* <!-- EMAIL --> */}
        <div className="formGroupEmail">

          <label className="formLabel">
            Email gửi (From) <span className="required">*</span>
          </label>

          <input
            type="text"
            className="formInputEmail"
            value="noreply@angiang.gov.vn"
          />

        </div>

        {/* <!-- PASSWORD --> */}
        <div className="formGroupPass">

          <label className="formLabel">
            Mật khẩu (Password) <span className="required">*</span>
          </label>

          <input
            type="password"
            className="formInputPass"
            value="123456789"
          />
          <i className="fa-regular fa-eye icon-eye-pass"></i>

          <div className="actionWrapper">

            <button className="actionButton">

              <i className="fa-solid fa-paper-plane"></i>

              Kiểm tra kết nối

            </button>

            <div className="successMessage">

              <i className="fa-solid fa-circle-check"></i>

              Kết nối thành công

            </div>

          </div>

        </div>

        {/* <!-- SEND MAIL --> */}
        <div className="formGroupSend">

          <label className="formLabel">
            Gửi email thử nghiệm đến <span className="required">*</span>
          </label>

          <div className="emailTestWrapper">

            <div className="emailTestInput">

              <input
                type="email"
                className="formInputSend"
                value="admin@angiang.gov.vn"
              />

            </div>

            <button className="actionButtonsend">

              <i className="fa-solid fa-paper-plane"></i>

              Gửi thử

            </button>

          </div>

        </div>

        {/* <!-- FROM NAME --> */}
        <div className="formGroupShowName">

          <label className="formLabel">
            Tên hiển thị (From Name)
          </label>

          <input
            type="text"
            className="formInput"
            value="Hệ thống dữ liệu ngành Công Thương An Giang"
          />

        </div>

      </div>

      {/* <!-- DESCRIPTION --> */}
      <div className="formGroupDescription">

        <label className="formLabel">
          Mô tả
        </label>

        <textarea className="formTextarea">
Cấu hình máy chủ gửi email mặc định của hệ thống.
        </textarea>

        <div className="textareaCount">
          58/255
        </div>

      </div>

    </div>
{/* 
    <!-- SMS --> */}
    <div className="sectionWrapper">

      <div className="sectionTitle">
        Cấu hình SMS
      </div>

      <div className="switchRow">

        <div className="switchLabel">
          Bật chức năng gửi SMS
        </div>

        <label className="switch">

          <input type="checkbox" checked />

          <span className="slider"></span>

        </label>

      </div>

      <div className="formGrid">

        {/* <!-- PROVIDER --> */}
        <div className="formGroup">

          <label className="formLabel">
            Nhà cung cấp <span className="required">*</span>
          </label>

          <select className="formSelectShare">

            <option>
              Viettel SMS
            </option>

          </select>

        </div>

        {/* <!-- USER --> */}
        <div className="formGroupBelow">

          <label className="formLabel">
            Tên đăng nhập (Username) <span className="required">*</span>
          </label>

          <input
            type="text"
            className="formShare"
            value="sct_angiang"
          />

        </div>

        {/* <!-- TIME --> */}
        <div className="formGroupTimeWait">

          <label className="formLabel">
            Thời gian chờ (giây)
          </label>

          <input
            type="number"
            className="formShare"
            value="30"
          />

        </div>

        {/* <!-- API URL --> */}
        <div className="formGroup">

          <label className="formLabel">
            API URL <span className="required">*</span>
          </label>

          <input
            type="text"
            className="formShare"
            value="https://rest.sms.viettel.vn/vt_sms/send"
          />

        </div>

        {/* <!-- PASSWORD --> */}
        <div className="formGroupBelow">

          <label className="formLabel">
            Mật khẩu (Password) <span className="required">*</span>
          </label>

          <input
            type="password"
            className="formShareKey"
            value="123456789"
          />

          <i className="fa-regular fa-eye eye-key"></i>

          <div className="actionWrapperBelow">

            <button className="actionButton">

              <i className="fa-solid fa-paper-plane"></i>

              Kiểm tra kết nối

            </button>

            <div className="successMessage">

              <i className="fa-solid fa-circle-check"></i>

              Kết nối thành công

            </div>

          </div>

        </div>

        {/* <!-- TEST PHONE --> */}
        <div className="formGroupTry">

          <label className="formLabel">
            Số điện thoại thử nghiệm <span className="required">*</span>
          </label>

          <div className="smsTestWrapper">

            <div className="smsTestInput">

              <input
                type="text"
                className="formInputTry"
                value="0912345678"
              />

            </div>

            <button className="actionButtonSendSms">

              <i className="fa-solid fa-paper-plane"></i>

              Gửi thử SMS

            </button>

          </div>

        </div>

        {/* <!-- API KEY --> */}
        <div className="formGroupShare">

          <label className="formLabel">
            API Key <span className="required">*</span>
          </label>

          <input
            type="password"
            className="formShare"
            value="123456789"
          />

        </div>

        {/* <!-- ENCODE --> */}
        <div className="formGroupShare">

          <label className="formLabelEncryption">
            Kiểu mã hóa
          </label>

          <select className="formSelectShareUTF">

            <option>
              UTF-8
            </option>

          </select>

        </div>

        {/* <!-- NOTE --> */}
        <div className="formGroupNote">

          <label className="formLabelWarning">
            Ghi chú
          </label>

          <textarea className="formTextareaWarning">
Cấu hình dịch vụ SMS dùng để gửi thông báo, cảnh báo đến người dùng.
          </textarea>

          <div className="textareaCount">
            61/255
          </div>

        </div>
{/* 
        <!-- SENDER --> */}
        <div className="formGroupSendID">

          <label className="formLabel">
            Sender ID <span className="required">*</span>
          </label>

          <input
            type="text"
            className="formInputSendID"
            value="AG-SCT"
          />

        </div>

      </div>

    </div>

    {/* <!-- NOTE --> */}
    <div className="noteBox">

      <div className="noteTitle">
        <i className="fa-solid fa-exclamation icon-exclamation"></i>
        Lưu ý :
      </div>

      <div className="noteItem">
        • Thông tin email/SMS chỉ được sử dụng bởi hệ thống để gửi thông báo tự động.
      </div>

      <div className="noteItem">
        • Vui lòng kiểm tra kết nối sau khi cập nhật để đảm bảo cấu hình chính xác.
      </div>

    </div>


            </div>
        );
    
}



export default SetupEmail;